var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-padding-remove uk-margin-remove",staticStyle:{"min-height":"50px"}},[_c('p',{staticClass:"error-message uk-margin-remove",style:(_vm.isVisible)},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }